import OrganizationOne from 'public/images/for-employers/organization/organization1.jpg';
import OrganizationTwo from 'public/images/for-employers/organization/organization2.jpg';
import Confidential from 'public/images/for-employers/employees/confidential.jpg';
import Help from 'public/images/for-employers/employees/help.jpg';
import Sometimes from 'public/images/for-employers/employees/sometimes.jpg';
import Onboard from './Onboard';
import Enroll from './Enroll';
import Book from './Book';
import IconInsurance from './IconInsurance';
import IconCustomized from './IconCustomized';
import IconSupport from './IconSupport';
import IconProfessional from './IconProfessional';
import IconClinical from './IconClinical';
import IconCreate from './IconCreate';
import IconMedical from './IconMedical';
import IconSun from './IconSun';

export const DESCRIPTION_ORGANIZATION = `We offer support to help your employees navigate life's challenges and continue to thrive at work. From providing access to psychological and medical resources, to offering guidance and a listening ear, we are committed to supporting your team.`;

export const DESCRIPTION_EMPLOYEES =
  'Life hands all of us unexpected situations that throw our personal and professional lives into turmoil. Find the practical and emotional support you need with your dedicated, fully confidential OneVillage concierge.';

export const organizationList = [
  {
    title: 'Book a Demo',
    description:
      'Learn how OneVillage can support your employees and their families with confidential 1x1 navigation',
    icon: <Book />,
  },
  {
    title: 'Enroll Online',
    description:
      'Upload some basic documents we’ll need to learn more about your health and benefits plan, and your employee base',
    icon: <Enroll />,
  },
  {
    title: 'Onboard in <10 mins',
    description:
      'After a brief intro session, a concierge will get in touch with each employee via email with more information',
    icon: <Onboard />,
  },
];

export const employeesList = [
  {
    title: 'Create a Confidential Login',
    description:
      'Join our private online community to find practical tips and up-to-date, medically reviewed news and information',
    icon: <IconCreate />,
  },
  {
    title: 'Meet Your Concierge',
    description:
      'Set up a short onboarding call with your concierge to share more about your situation and discuss how we can help',
    icon: <IconMedical />,
  },
  {
    title: 'Focus on What’s Important to You',
    description:
      'Take time for yourself while OneVillage provides research, support, and matching to professional and peer coaches',
    icon: <IconSun />,
  },
];

export const organizationContent = [
  {
    title: 'A Safe Space for Employees',
    description:
      'OneVillage is confidential by design, in order to create a safe space for employees to share concerns about anything causing them stress around their health and wellbeing, or the health and wellbeing of someone they love.',
    img: OrganizationOne,
  },
  {
    title: 'A Partner for Employers',
    description:
      'OneVillage ensures your employees get the confidential support they need to be their best through difficult life situations without requiring HR intervention. We know your employees are your family, so we treat them like ours as well.',
    img: OrganizationTwo,
  },
];

export const employeesContent = [
  {
    title: 'Sometimes life throws you a curveball',
    description: `Most people don't understand how overwhelming an unexpected situation like cancer, depression, or substance use disorder can be until it affects you or a loved one. Insurance carriers often lack a personal touch, health care systems are complex and hard to navigate, and let's not forget the tremendous physical and mental toll stress can take on your mind and body.`,
    img: Sometimes,
  },
  {
    title: 'We’re here to help you find a path forward',
    description:
      'Your dedicated concierge will help research care options, find emotional support, and understand how your company provided benefits can support you with any type of health or wellbeing concern.',
    img: Help,
  },
  {
    title: `We're always here, and always completely confidential`,
    description:
      'OneVillage is a safe space to receive fully confidential support for yourself or a family member. We’ll never share your information with anyone, even your employer.',
    img: Confidential,
  },
];

export const whatWeWillDoContant = [
  { title: 'Insurance and Benefit Navigation', icon: <IconInsurance /> },
  { title: 'Customized Research on Care Options', icon: <IconCustomized /> },
  { title: '24x7 Support via Phone, Email and Chat ', icon: <IconSupport /> },
  { title: 'Professional & Peer Support Matching', icon: <IconProfessional /> },
  { title: 'Clinical Trial and Genetic Counseling', icon: <IconClinical /> },
];
